export const API='/api/1'
export const API_BO=''